import { render } from "./UiScaleControl.vue?vue&type=template&id=a84b653e&scoped=true&ts=true"
import script from "./UiScaleControl.vue?vue&type=script&lang=ts"
export * from "./UiScaleControl.vue?vue&type=script&lang=ts"

import "./UiScaleControl.vue?vue&type=style&index=0&id=a84b653e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84b653e"]])

export default __exports__